import { AxiosResponseHeaders, RawAxiosResponseHeaders } from 'axios';

export type JSONResponse = { [key: string]: never };

interface IAPIError extends Error {
	/**
	 * The URL of the request
	 *
	 * @type {string}
	 * @memberof IAPIError
	 */
	url: string;
	/**
	 * Optional error stacktrace
	 *
	 * @type {string}
	 * @memberof IAPIError
	 */
	stacktrace?: string;
	/**
	 * The response object received from the server
	 *
	 * @type {Response}
	 * @memberof IAPIError
	 * @deprecated Switch to using responseBody, statusCode, and responseHeaders as a separate args.
	 */
	response?: Response;
	/**
	 * The response body received from the server
	 *
	 * @type {(string | JSONResponse)}
	 * @memberof IAPIError
	 */
	responseBody?: string | JSONResponse;
	/**
	 * The request body sent to the server
	 *
	 * @type {(BodyInit | null)}
	 * @memberof IAPIError
	 */
	requestBody?: BodyInit | null;
	/**
	 * The status code of the response
	 *
	 * @type {number}
	 * @memberof IAPIError
	 */
	statusCode?: number;
	/**
	 * The response headers received from the server
	 *
	 * @type {(RawAxiosResponseHeaders | AxiosResponseHeaders | null)}
	 * @memberof IAPIError
	 */
	responseHeaders?: RawAxiosResponseHeaders | AxiosResponseHeaders | null;
}

export class APIError extends Error implements IAPIError {
	url: string;
	statusCode: number;
	traceId: string;
	responseBody: string | JSONResponse;
	requestBody: BodyInit | null;
	responseHeaders: RawAxiosResponseHeaders | AxiosResponseHeaders | null;

	constructor({
		name,
		url,
		message,
		stacktrace,
		response,
		responseBody,
		requestBody,
		statusCode,
		responseHeaders,
	}: IAPIError) {
		super(message);

		this.name = name ?? 'APIError';
		this.url = url;
		this.stack = stacktrace;
		this.statusCode = statusCode || -999;
		this.traceId = responseHeaders?.traceid || '';
		this.responseBody = responseBody || '';
		this.requestBody = requestBody || null;
		this.responseHeaders = responseHeaders || null;

		if (response) {
			this.statusCode = response?.status || -999;
			this.traceId = response?.headers.get('traceid') || '';
		}
	}
}
